// components/CapturaPosCard.js — pos-pedir-celular (19-oct-2026). Tablero de CAPTURA del POS en el
// Resumen de ventas (solo admin/coordinador): % de ventas POS con celular y con correo, por semana y
// por vendedor, + las ventas «sin datos» declaradas. Consume GET /api/pos/captura-kpis (espejo).
import React, { useEffect, useState } from 'react';
import { TEXT, STATE } from '../styles/tokens';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const fmtPct = (p) => (p == null ? '—' : `${p}%`);
// El color del % por umbral: ≥80 bien, 50-79 regular, <50 mal (sobre el objetivo de captura).
const colorPct = (p) => (p == null ? TEXT.tertiary : p >= 80 ? STATE.success.text : p >= 50 ? STATE.warning.text : STATE.error.text);

export default function CapturaPosCard({ userRole }) {
  const [datos, setDatos] = useState(null);
  const [estado, setEstado] = useState('cargando');
  const visible = userRole === 'admin' || userRole === 'coordinador';

  useEffect(() => {
    if (!visible) return;
    fetch(`${API_URL}/api/pos/captura-kpis`, { headers: { Authorization: `Bearer ${localStorage.getItem('token') || ''}` } })
      .then(async (r) => ({ ok: r.ok, d: await r.json().catch(() => ({})) }))
      .then(({ ok, d }) => { if (!ok) { setEstado('error'); return; } setDatos(d); setEstado('ok'); })
      .catch(() => setEstado('error'));
  }, [visible]);

  if (!visible) return null;

  const th = { textAlign: 'right', padding: '4px 8px', color: TEXT.tertiary, fontWeight: 500 };
  const td = { textAlign: 'right', padding: '4px 8px' };

  return (
    <section className="resumen-section" style={{ marginTop: 16 }}>
      <h3 style={{ fontSize: 15, margin: '0 0 4px' }}>Captura de datos en el POS</h3>
      <p style={{ fontSize: 12, color: TEXT.tertiary, margin: '0 0 8px' }}>
        De las ventas POS, cuántas quedaron con celular y con correo — por semana y por vendedor.
        Las «sin datos» llevan su motivo declarado.
      </p>
      {estado === 'cargando' && <p style={{ fontSize: 13 }}>Cargando…</p>}
      {estado === 'error' && <p style={{ fontSize: 13, color: STATE.error.text }}>No se pudo cargar la captura del POS.</p>}
      {estado === 'ok' && datos && (datos.semanas || []).length === 0 && (
        <p style={{ fontSize: 13, color: TEXT.tertiary }}>Sin ventas POS en las últimas semanas.</p>
      )}
      {estado === 'ok' && datos && (datos.semanas || []).length > 0 && (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr>
              <th style={{ ...th, textAlign: 'left' }}>Semana / vendedor</th>
              <th style={th}>Ventas POS</th>
              <th style={th}>Con celular</th>
              <th style={th}>Con correo</th>
              <th style={th}>Sin datos</th>
            </tr>
          </thead>
          <tbody>
            {datos.semanas.map((s) => (
              <React.Fragment key={s.semana}>
                <tr style={{ borderTop: '2px solid #e5e0ef', fontWeight: 600 }}>
                  <td style={{ padding: '4px 8px' }}>Semana del {s.semana}</td>
                  <td style={td}>{s.total.ventas}</td>
                  <td style={{ ...td, color: colorPct(s.total.pct_celular) }}>{s.total.con_celular} ({fmtPct(s.total.pct_celular)})</td>
                  <td style={{ ...td, color: colorPct(s.total.pct_correo) }}>{s.total.con_correo} ({fmtPct(s.total.pct_correo)})</td>
                  <td style={td}>{s.total.sin_datos || 0}</td>
                </tr>
                {Object.entries(s.vendedoras).sort((a, b) => b[1].ventas - a[1].ventas).map(([v, c]) => (
                  <tr key={`${s.semana}|${v}`} style={{ borderTop: '1px solid #f0edf6' }}>
                    <td style={{ padding: '4px 8px 4px 24px', color: TEXT.secondary }}>{v}</td>
                    <td style={td}>{c.ventas}</td>
                    <td style={{ ...td, color: colorPct(c.pct_celular) }}>{c.con_celular} ({fmtPct(c.pct_celular)})</td>
                    <td style={{ ...td, color: colorPct(c.pct_correo) }}>{c.con_correo} ({fmtPct(c.pct_correo)})</td>
                    <td style={td}>{c.sin_datos || 0}</td>
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
